<template>
  <div
    class="no-results"
    v-if="
      suggestions_by_radius.flights.length == 0 && suggestions_by_time_window.flights.length == 0
    "
  >
    <filters-tags />
    <div class="panel">
      <h6 class="no-results--heading">
        Oppps! Non abbiamo trovato proposte per la tua ricerca. Che fare?
      </h6>
      <b-row>
        <b-col md="4">
          <div class="no-results--item">
            <div class="no-results--icon" v-html="filters_gray_rounded"></div>
            <div class="no-results--title">Elimina i filtri</div>
            <div class="no-results--text">
              Hai inserito troppi filtri?
              <br />
              Prova con meno filtri.
            </div>
          </div>
        </b-col>
        <b-col md="4">
          <div class="no-results--item">
            <div class="no-results--icon" v-html="calendar_gray_rounded"></div>
            <div class="no-results--title">Prova su altre date</div>
            <div class="no-results--text">
              Le compagnie low cost hanno ridotto il numero di voli settimanali per cui prova tutti
              i giorni della settimana.
            </div>
          </div>
        </b-col>
        <b-col md="4">
          <div class="no-results--item">
            <div class="no-results--icon" v-html="pin_gray_rounded"></div>
            <div class="no-results--title">Usa il nome della città</div>
            <div class="no-results--text">
              Non usare il nome dell'aeroporto (ex. Malpensa o MXP) ma il nome della città (Tutti
              gli aeroporti di Milano).
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  filters_gray_rounded,
  calendar_gray_rounded,
  pin_gray_rounded,
} from '@/components/svg/flight';
import FiltersTags from '@/components/blocks/filters-tags';

export default {
  name: 'no-results',
  components: {
    'filters-tags': FiltersTags,
  },
  props: {},
  created() {
    this.filters_gray_rounded = filters_gray_rounded;
    this.calendar_gray_rounded = calendar_gray_rounded;
    this.pin_gray_rounded = pin_gray_rounded;
  },
  computed: {
    suggestions: {
      get() {
        return this.$store.state.liveflight.suggestions;
      },
      set() {},
    },
    suggestions_by_radius: {
      get() {
        if (Object.keys(this.suggestions) == 0) return { flights: [] };
        if (Object.keys(this.suggestions.by_radius) == 0) return { flights: [] };
        if (this.suggestions.by_radius.flights == undefined) return { flights: [] };
        return this.suggestions.by_radius;
      },
      set() {},
    },
    suggestions_by_time_window: {
      get() {
        if (Object.keys(this.suggestions) == 0) return { flights: [] };
        if (Object.keys(this.suggestions.by_time_window) == 0) return { flights: [] };
        if (this.suggestions.by_time_window.flights == undefined) return { flights: [] };
        return this.suggestions.by_time_window;
      },
      set() {},
    },
  },
};
</script>

<style lang="scss">
.no-results {
  text-align: center;
  margin-bottom: $grid-gutter-width;
  .panel {
    padding: $grid-gutter-width $grid-gutter-width;
  }
  &--heading {
    @extend .h6 !optional;
    margin-bottom: $grid-gutter-width;
  }
  &--item {
    //text-align: center;
  }
  &--icon {
    margin-bottom: 8px;
  }
  &--title {
    font-size: 16px;
  }
  &--text {
    font-size: 12px;
    max-width: 200px;
    margin: 0 auto;
  }
}
</style>
